<template>
  <div class="file-uploader-container" onclick="document.getElementById('fileUpload').click();">
    <input type="file" style="display:none;" id="fileUpload" name="file" :accept="allowedFiles"
           @change="onChangeHandler"/>
    <i class="fas fa-upload upload-icon"></i>
    <p class="file-uploader-label" v-text="text"></p>
  </div>
</template>

<script>
export default {
  props: {
    text: String,
    allowedFiles: String
  },
  name: 'FileUploader',
  data() {
    return {
      file: null,
      title: this.text,
      allowedFilesTemp: this.allowedFiles
    }
  },
  methods: {
    onChangeHandler(e) {
      this.file = e.target.files[0];
    }
  },
  watch: {
    file: {
      handler() {
        this.$emit('file-upload', this.file);
      },
      deep: true
    },
    text: {
      handler(newVal) {
        this.title = newVal;
      },
      deep: true
    },
    allowedFiles: {
      handler(newVal) {
        this.allowedFilesTemp = newVal;
      },
      deep: true
    }
  }
}
</script>

<style>
.file-uploader-container {
  display: flex;
  color: var(--dark-grey);
}

.file-uploader-container:hover {
  color: var(--primary-green);
  cursor: pointer;
}

.file-uploader-label {
  font-size: 25px;
  margin-top: 10px;
  margin-left: 10px;
}

.upload-icon {
  font-size: 35px;
}
</style>
